import { truncateToTwoDecimalFormatted } from '../../utils/utils';

export const normalizePhone = (value) => {
  if (!value) {
    return '';
  }

  const onlyNums = value.replace(/[^\d]/g, '').slice(0, 10);

  if (onlyNums.length === 10) {
    return onlyNums.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  }
  if (onlyNums.length > 6) {
    return (
      onlyNums.slice(0, 3) +
      '-' +
      onlyNums.slice(3, 6) +
      '-' +
      onlyNums.slice(6, 10)
    );
  }
  if (onlyNums.length > 3) {
    return onlyNums.slice(0, 3) + '-' + onlyNums.slice(3);
  }
  return onlyNums;
};

export const normalizeSocialSecurity = (value) => {
  if (!value) {
    return '';
  }

  const onlyNums = value.replace(/[^\d]/g, '').slice(0, 9);

  if (onlyNums.length > 5) {
    return (
      onlyNums.slice(0, 3) +
      '-' +
      onlyNums.slice(3, 5) +
      '-' +
      onlyNums.slice(5, 9)
    );
  }
  if (onlyNums.length > 3) {
    return onlyNums.slice(0, 3) + '-' + onlyNums.slice(3, 5);
  }
  return onlyNums;
};

export const normalizeDate = (value) => {
  if (!value) {
    return '';
  }

  const onlyNums = value.replace(/[^\d]/g, '');

  if (onlyNums.length > 4) {
    return (
      onlyNums.slice(0, 2) +
      '/' +
      onlyNums.slice(2, 4) +
      '/' +
      onlyNums.slice(4, 8)
    );
  }
  if (onlyNums.length > 2) {
    return onlyNums.slice(0, 2) + '/' + onlyNums.slice(2);
  }
  return onlyNums;
};

export const normalizeCurrencyFormat = (value) => {
  // note: don't actually check for value of 0, but just text $0
  // for extremely rare case they want to type a decimal like $0.50
  if (value.length === 0 || value === '$0' || value === '$') {
    return null;
  }

  if (
    value.includes('.') &&
    value.indexOf('.') >= value.length - 3 &&
    value.indexOf('.') <= value.length - 1
  ) {
    return value;
  }

  return truncateToTwoDecimalFormatted(value);
};

export const normalizeNumbers = (value) => {
  if (!value) {
    return '';
  }

  const nums = value.replace(/[^\d]/g, '');

  return nums;
};

export const normalizeAlpha = (value) => {
  return value ? value.replace(/[^a-zA-Z\s]/g, '') : '';
};

export const normalizeNameSuffix = (value) => {
  return value ? value.replace(/[^a-zA-Z\s.]/g, '') : '';
};

export const normalizeBankAccount = (value) => {
  if (!value) {
    return '';
  }
  const alpha = value.replace(/[^\-0-9]/g, '');
  return alpha;
};
